var isWebColor=color=>"currentcolor"===color||"currentColor"===color||"inherit"===color||0===color.indexOf("var(");export default isWebColor;